var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgKidneyCardE4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 158,
    height: 158,
    rx: 12,
    fill: "#fff",
    stroke: "#BE531C",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.792 102.694c-21.197-8.982-12.833-39.304 1.883-44.313 6.105-2.078 12.838 4.817 12.797 9.097-.02 1.85-.97 3.656-1.96 5.536-1.3 2.47-2.67 5.068-2.088 8.073 1.024 5.293 2.171 14.225-.785 18.463-2.956 4.24-5.927 4.805-9.847 3.144zM102.324 58.381c14.716 5.01 23.082 35.33 1.883 44.313-3.92 1.663-6.891 1.096-9.847-3.144-2.956-4.238-1.809-13.17-.784-18.463.581-3.005-.789-5.605-2.088-8.073-.991-1.88-1.941-3.686-1.959-5.536-.043-4.28 6.692-11.175 12.795-9.097zM91.147 87.064l.136 1.955h.023l.006-.002c-.11.016-.22.04-.327.07-.33.094-.643.244-.923.444-.566.403-1.397 1.301-1.397 3.567v10.951a1.951 1.951 0 0 1-3.902 0v-10.95c0-3.463 1.385-5.582 3.033-6.764a6.916 6.916 0 0 1 2.85-1.182c.103-.017.207-.03.311-.04l.032-.003h.02c0-.002.005-.002.138 1.954zM72.853 87.064c-.133 1.955-.135 1.955-.137 1.955h-.023l-.006-.002.047.006c.433.079.844.251 1.203.505.566.406 1.397 1.304 1.397 3.57v10.951a1.951 1.951 0 0 0 3.902 0v-10.95c0-3.463-1.385-5.582-3.035-6.764a6.912 6.912 0 0 0-2.849-1.182 4.744 4.744 0 0 0-.312-.04l-.03-.003h-.02c0-.002-.003-.002-.137 1.954z",
    fill: "#8B5A5A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKidneyCardE4);
export default __webpack_public_path__ + "static/media/kidneyCardE4.8ceb1747.svg";
export { ForwardRef as ReactComponent };